import axios from 'axios';
import api from './Api';
import { IArquivoOperacao, IArquivoOperacaoPaged } from '../interfaces/IArquivoOperacao';

interface UploadUrlResponse {
    signedUrl: string;
    generatedFileName: string;
}

class ArquivoOperacaoService {
    async listar(esteiraId: number, page: number = 1, perPage: number = 10, tipo?: string): Promise<IArquivoOperacaoPaged> {
        const { data } = await api.get<IArquivoOperacaoPaged>('ArquivoOperacao', {
            params: { esteiraId, page, perPage, ...(tipo ? { tipo } : {}) }
        });
        return data;
    }

    async gerarUrl(nomeOriginal: string, contentType: string = 'application/octet-stream'): Promise<UploadUrlResponse> {
        const { data } = await api.post<UploadUrlResponse>('ArquivoOperacao/gerar-url', {
            originalFileName: nomeOriginal,
            contentType
        });
        return data;
    }

    async enviarParaStorage(signedUrl: string, file: File): Promise<void> {
        await axios.put(signedUrl, file, {
            headers: { 'Content-Type': file.type || 'application/octet-stream' }
        });
    }

    async registrar(esteiraId: number, tipo: string, nomeGerado: string, nomeOriginal: string, relatorioId?: number): Promise<IArquivoOperacao> {
        const { data } = await api.post<IArquivoOperacao>('ArquivoOperacao', {
            esteiraId,
            tipo,
            nomeGerado,
            nomeOriginal,
            ...(relatorioId != null ? { relatorioId } : {})
        });
        return data;
    }

    async listarPorCartao(esteiraId: number, cartaoId: number, page: number = 1, perPage: number = 10): Promise<IArquivoOperacaoPaged> {
        const { data } = await api.get<IArquivoOperacaoPaged>(`ArquivoOperacao/cartao/${cartaoId}`, {
            params: { esteiraId, page, perPage }
        });
        return data;
    }

    async processarSaldoInicial(esteiraId: number, cartaoId: number, fileName: string, arquivoOperacaoId: number): Promise<void> {
        await api.post(`saldoinicial/${esteiraId}/${cartaoId}/processar`, { fileName, arquivoOperacaoId });
    }
}

export default new ArquivoOperacaoService();
